import { render } from "./호스피스완화센터.vue?vue&type=template&id=b0caa974"
import script from "./호스피스완화센터.vue?vue&type=script&lang=js"
export * from "./호스피스완화센터.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__